import { render } from "./ContactArea.vue?vue&type=template&id=f5c584a4"
import script from "./ContactArea.vue?vue&type=script&lang=js"
export * from "./ContactArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__